/* MEDIBUD — bundle page JS tweak layer. Loaded after the template script,
   so anything here overrides it. Future bundle JS edits go in this file. */
(function(){
  var SZ={'54153281470748':'5 L','54153281536284':'1 L','54153281601820':'20 L'};
  var FD={'54153281470748':'444 feeds','54153281536284':'88 feeds','54153281601820':'1,777 feeds'};
  var SAVE={'54153281470748':'$29','54153281536284':'$9','54153281601820':'$81'};
  var PRICE={'54153281470748':'$169','54153281536284':'$55','54153281601820':'$549'};

  function render(){
    var vc=document.querySelector('.valuecard');if(!vc)return;
    var v=document.querySelector('.variant.sel')||document.querySelector('.variant');if(!v)return;
    var id=v.getAttribute('data-variant')||'';
    if(vc.dataset.mbBox===id&&vc.querySelector('.mb-box'))return;
    var sz=SZ[id]||'',fd=FD[id]||'';
    vc.dataset.mbBox=id;
    vc.innerHTML='<div class="mb-box">'+
      '<span class="mb-boxh">In the box</span>'+
      '<div class="mb-brow"><span class="mb-btag p1">Phase 1</span><span class="mb-bl"><b>Medigrow\u00ae '+sz+'</b><small>Roots, leaves &amp; lawns</small></span></div>'+
      '<div class="mb-brow"><span class="mb-btag p2">Phase 2</span><span class="mb-bl"><b>Medibud\u00ae '+sz+'</b><small>Flowers, fruit &amp; yield</small></span></div>'+
      '<div class="mb-bfoot">'+fd+' \u00b7 a full grow-to-bloom season</div>'+
      '<div class="mb-bfoot2">Just add water. Spray it on the leaves as a foliar feed, pour it in at the roots, or run it through irrigation.</div>'+
    '</div>';
  }

  /* Live Okendo rating in the buy box only. The full Okendo widget is NOT used on
     this page — it renders unstyled on the blank layout. Curated review cards stay. */
  function okendo(){
    var src=document.getElementById('mb-oke-src');if(!src)return;
    var starEl=src.querySelector('.oke-sr');
    var rating=document.querySelector('#buybox .rating');
    if(starEl&&rating&&!rating.dataset.mbOke){
      rating.dataset.mbOke='1';
      rating.innerHTML='';
      rating.appendChild(starEl);
      rating.classList.add('mb-oke-rating');
    }
    var revs=document.getElementById('reviews');
    if(revs)revs.style.display='none';
  }

  /* Keep the curated review cards sitting just above the FAQ */
  function placeResults(){
    var photo=document.querySelector('.results');if(!photo||photo.dataset.mbSwap)return;
    var faq=document.getElementById('faq');if(!faq)return;
    photo.dataset.mbSwap='1';
    faq.parentNode.insertBefore(photo,faq);
  }

  /* Sticky bar was hardcoded to 5 L — make it follow the selected size */
  function sticky(){
    var bar=document.getElementById('stickybar');if(!bar)return;
    var v=document.querySelector('.variant.sel')||document.querySelector('.variant');if(!v)return;
    var id=v.getAttribute('data-variant')||'';
    if(!SZ[id])return;
    var n=bar.querySelector('.sname'),s=bar.querySelector('.ssub');
    if(n)n.textContent='The Bundle \u00b7 '+SZ[id];
    if(s)s.textContent=PRICE[id]+' \u00b7 save '+SAVE[id]+' \u00b7 '+FD[id];
  }

  /* Copy the template pass doesn't catch */
  function copyFix(){
    var T=[['greener, healthier difference','visible, healthier difference'],
           ['Greener Guarantee','Growers Guarantee'],
           ['a greener, healthier','a visible, healthier'],
           ['$0.30 a feed','38c a feed'],
           ['5,000 L combined','4,000 L combined'],
           ['Whole-Garden System','Whole-Garden Bundle']];
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null),n;
    while(n=w.nextNode()){
      var t=n.nodeValue;if(!t||t.length<4)continue;
      if(n.parentNode&&n.parentNode.nodeName==='SCRIPT')continue;
      var o=t;
      for(var i=0;i<T.length;i++){if(t.indexOf(T[i][0])>-1)t=t.split(T[i][0]).join(T[i][1]);}
      if(t!==o)n.nodeValue=t;
    }
  }

  /* FAQ 4 Sep (owner review) — only Medibud carries a full NPK with values for all three, so the
     "right NPK at each stage" line is gone. Q2 rewritten. "How is this different" question and
     answer matched to the Medibud PDP wording, adapted for two bottles. Visible + FAQ JSON-LD. */
  var FAQ2='Because plants need different nutrients at different stages. Medigrow is nitrogen-led for roots, leaf and growth; Medibud carries the full NPK balance, with phosphorus and potassium up front for flowers and fruit. A single all-purpose bottle compromises on both. The system gives each stage what it actually needs, so you stop guessing.';
  var RX2=/Because plants need different nutrients at different stages: nitrogen for growth[^"]*?so you stop guessing\./;
  var Q6='How is this different from Seasol or the hardware-store bottle?';
  var FAQ6='Seasol is mainly a seaweed tonic, excellent for stress and roots, but very low in NPK, so it isn\u2019t a complete feed. The Whole-Garden Bundle is two complete, farm-grade mineral plant food concentrates: Medigrow with the nitrogen and trace elements growing plants need, and Medibud with the phosphorus and potassium fruiting plants need. No fillers, no fishy smell.';
  var RX6Q=/How is this different from Seasol or Charlie Carp\?/g;
  var RX6A=/Those are single products[^"]*?no fishy smell\./;
  var RXSYS=/Whole-Garden System/g;
  function faqFix(){
    document.querySelectorAll('.faq details').forEach(function(d){
      var s=d.querySelector('summary');if(!s)return;
      var a=d.querySelector('.ans');if(!a)return;
      if(/Why two products/i.test(s.textContent||'')&&a.textContent.indexOf('full NPK balance')<0)a.textContent=FAQ2;
      if(/Seasol or Charlie Carp/i.test(s.textContent||'')){
        var pl=s.querySelector('.pl');
        s.textContent=Q6;if(pl)s.appendChild(pl);
        a.textContent=FAQ6;
      }
    });
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function(sc){
      var t=sc.textContent||'';var o=t;
      t=t.replace(RX2,FAQ2).replace(RX6Q,Q6).replace(RX6A,FAQ6.replace(/\u2019/g,"'")).replace(RXSYS,'Whole-Garden Bundle');
      if(t!==o)sc.textContent=t;
    });
  }

  /* COMPARE TABLE 4 Sep (owner review) — home-page style table, rows tailored to the system.
     8 Sep pm (owner): was appended INSIDE the "Why growers choose the bundle" section and read as
     one merged block. Now its own forest section. Placed AFTER the size helper (not straight after
     the benefits) so two forest sections never touch: benefits / size helper / compare / the maths. */
  var TICK='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#C6F03C"/><path d="M7.4 12.4l3 3 6-6.4" stroke="#0F3D24" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CROSS='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10.6" fill="none" stroke="#FAF9F8" stroke-width="1.7"/><path d="M8.6 8.6l6.8 6.8M15.4 8.6l-6.8 6.8" stroke="#FAF9F8" stroke-width="2.6" stroke-linecap="round"/></svg>';
  var OTH='<svg class="mb-cmp-oth" viewBox="0 0 92 62" fill="none" aria-hidden="true"><g transform="translate(2 2)"><rect x="16" y="2" width="12" height="6" rx="1.4" fill="#aab2a8"/><path d="M15 11h14c1.4 2.8 3.6 3.8 3.6 8.2V52a4.6 4.6 0 0 1-4.6 4.6H16A4.6 4.6 0 0 1 11.4 52V19.2c0-4.4 2.2-5.4 3.6-8.2Z" fill="#d2d8cf" stroke="#b4bcb1" stroke-width="1.3"/><rect x="14" y="28" width="16" height="13" rx="2" fill="#c0c8be"/></g><g transform="translate(48 8) scale(.88)"><rect x="16" y="2" width="12" height="6" rx="1.4" fill="#aab2a8"/><path d="M15 11h14c1.4 2.8 3.6 3.8 3.6 8.2V52a4.6 4.6 0 0 1-4.6 4.6H16A4.6 4.6 0 0 1 11.4 52V19.2c0-4.4 2.2-5.4 3.6-8.2Z" fill="#d2d8cf" stroke="#b4bcb1" stroke-width="1.3"/><rect x="14" y="28" width="16" height="13" rx="2" fill="#c0c8be"/></g></svg>';
  var ROWS=['Two-phase system, grow then bloom','Full NPK across the season (4-0-0 + 1-1-4)','Chelated minerals, no leaf burn','Farm-grade concentration','No fishy smell','Under 40c a feed','30-day money-back guarantee'];
  var CSS='.mb-cmpsec{position:relative;background:#0F3D24;color:#fff;padding:56px 0 64px;font-family:"Hanken Grotesk",Helvetica,Arial,sans-serif}'+
    '.mb-cmpsec .mb-cmpwrap{max-width:1120px;margin:0 auto;padding:0 clamp(20px,5vw,44px)}'+
    '.mb-cmpsec .mb-cmpeye{display:inline-flex;align-items:center;gap:11px;font-family:"JetBrains Mono",monospace;font-size:11px;font-weight:700;letter-spacing:.24em;text-transform:uppercase;color:#C6F03C}'+
    '.mb-cmpsec .mb-cmpeye::before,.mb-cmpsec .mb-cmpeye::after{content:"";width:22px;height:1.5px;background:currentColor;opacity:.38;border-radius:2px;flex:none}'+
    '.mb-cmpsec h2{font-size:clamp(30px,8vw,46px);line-height:1.04;font-weight:900;letter-spacing:-.03em;color:#fff;margin:14px 0 0;text-wrap:balance}'+
    '.mb-cmpsec h2 em{font-style:normal;background:#C6F03C;color:#0F3D24;border-radius:8px;padding:.02em 10px;-webkit-box-decoration-break:clone;box-decoration-break:clone}'+
    '.mb-cmpsec .mb-cmplead{font-size:16.5px;line-height:1.55;color:#9FC77E;max-width:52ch;margin:14px 0 0}'+
    '.mb-cmp{margin:30px 0 0;max-width:780px;font-family:"Hanken Grotesk",Helvetica,Arial,sans-serif}'+
    '.mb-cmp .row{display:grid;grid-template-columns:minmax(0,40fr) minmax(0,34fr) minmax(0,26fr);align-items:stretch}'+
    '.mb-cmp .lab{display:flex;align-items:center;font-size:15.5px;font-weight:700;color:#EAF3CF;line-height:1.3;padding:22px 10px 22px 0;border-top:1px solid #fff;min-width:0}'+
    '.mb-cmp .cell{display:flex;align-items:center;justify-content:center;padding:22px 0;text-align:center}'+
    '.mb-cmp .cell svg{width:44px;height:44px;flex:none;display:block}'+
    '.mb-cmp .them{border-top:1px solid #fff}'+
    '.mb-cmp .us{background:#fff}'+
    '.mb-cmp .row.head .lab,.mb-cmp .row.head .them{border-top:none}'+
    '.mb-cmp .row.head .us{border-radius:24px 24px 0 0;box-shadow:0 -18px 34px -18px rgba(0,0,0,.45)}'+
    '.mb-cmp .row.head .cell{flex-direction:column;gap:9px;padding-top:18px;padding-bottom:16px}'+
    '.mb-cmp .row.head .cell svg{width:auto;height:auto}'+
    '.mb-cmp .h{font-family:"JetBrains Mono",monospace;font-size:10.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#9FC77E;text-align:center;line-height:1.35;width:100%}'+
    '.mb-cmp .us .h{color:#0F3D24}'+
    '.mb-cmp .mb-cmp-prod{display:block;width:96px;height:76px;max-width:88%;object-fit:contain;margin:0 auto}'+
    '.mb-cmp .mb-cmp-oth{display:block;width:62px;height:44px;max-width:80%;margin:0 auto}'+
    '.mb-cmp .row.last .lab,.mb-cmp .row.last .them{border-bottom:1px solid #fff}'+
    '.mb-cmp .row.last .us{border-bottom:1px solid #fff}'+
    '@media(min-width:620px){.mb-cmpsec{padding:72px 0 80px}.mb-cmp{margin-top:38px}.mb-cmp .lab{font-size:17px;padding:26px 16px 26px 0}.mb-cmp .cell{padding:26px 0}.mb-cmp .cell svg{width:54px;height:54px}.mb-cmp .mb-cmp-prod{width:150px;height:118px}.mb-cmp .mb-cmp-oth{width:84px;height:60px}.mb-cmp .h{font-size:11.5px}}';
  function compare(){
    if(document.querySelector('.mb-cmpsec'))return;
    var sec=document.getElementById('size-helper')||document.querySelector('.benefits');if(!sec)return;
    var st=document.createElement('style');st.textContent=CSS;document.head.appendChild(st);
    var wrap=document.createElement('section');wrap.className='mb-cmpsec';wrap.setAttribute('aria-label','How the bundle compares');
    var html='<div class="mb-cmpwrap"><span class="mb-cmpeye">Side by side</span>'+
      '<h2>How the bundle <em>stacks up</em></h2>'+
      '<p class="mb-cmplead">Two farm-grade concentrates against the bottle from the hardware aisle.</p>'+
      '<div class="mb-cmp">'+
      '<div class="row head"><span class="lab" aria-hidden="true"></span>'+
      '<span class="cell us h"><img class="mb-cmp-prod" src="https://cdn.shopify.com/s/files/1/0820/4215/9388/files/medibud-medigrow-bundle.png?v=1780460636&width=400" alt="Medigrow and Medibud bottles" loading="lazy">Medibud<br>system</span>'+
      '<span class="cell them h">'+OTH+'Typical<br>retail</span></div>';
    ROWS.forEach(function(r,i){
      html+='<div class="row'+(i===ROWS.length-1?' last':'')+'"><span class="lab">'+r+'</span><span class="cell us">'+TICK+'</span><span class="cell them">'+CROSS+'</span></div>';
    });
    html+='</div></div>';
    wrap.innerHTML=html;
    sec.insertAdjacentElement('afterend',wrap);
  }

  /* Close the pale seam above the marquee band without cramping the guarantee. */
  function seam(){
    if(document.body.dataset.mbSeam)return;
    var hero=document.querySelector('.hero');if(!hero)return;
    var host=hero.parentElement;if(!host)return;
    var kids=[].slice.call(host.children),hi=kids.indexOf(hero),band=null,bi=-1;
    for(var i=hi+1;i<kids.length;i++){
      if(/FARM-GRADE MINERALS|KID & PET SAFE/i.test(kids[i].textContent||'')){band=kids[i];bi=i;break;}
    }
    if(!band)return;
    document.body.dataset.mbSeam='1';
    hero.style.paddingBottom='34px';
    hero.style.marginBottom='0';
    band.style.marginTop='0';
    for(var j=hi+1;j<bi;j++){
      kids[j].style.background='#F1F1EC';
      kids[j].style.marginTop='0';
      kids[j].style.marginBottom='0';
    }
  }

  function all(){render();okendo();placeResults();sticky();copyFix();faqFix();compare();seam();}

  function boot(){
    all();
    if(document.body.dataset.mbBoxBoot)return;
    document.body.dataset.mbBoxBoot='1';
    document.querySelectorAll('.variant').forEach(function(v){
      v.addEventListener('click',function(){setTimeout(function(){render();sticky();},30);setTimeout(function(){render();sticky();},150);});
    });
    var vc=document.querySelector('.valuecard');
    if(vc&&window.MutationObserver){
      new MutationObserver(function(){
        if(!vc.querySelector('.mb-box')){vc.dataset.mbBox='';render();}
      }).observe(vc,{childList:true});
    }
  }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  setTimeout(boot,750);
  setTimeout(all,1400);
  setTimeout(okendo,2400);
})();
